(() => {
  const content = document.querySelector('[data-journal-content]');
  const toc = document.querySelector('[data-journal-toc]');
  const list = document.querySelector('[data-journal-toc-list]');

  if (content && toc && list) {
    const headings = [...content.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim());
    if (headings.length >= 3) {
      const used = new Set();
      headings.forEach((heading, index) => {
        let id = heading.id || heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
        const base = id;
        let suffix = 2;
        while (used.has(id) || document.getElementById(id)) id = `${base}-${suffix++}`;
        heading.id = id;
        used.add(id);
        const item = document.createElement('li');
        item.className = `havn-journal-toc__${heading.tagName.toLowerCase()}`;
        const link = document.createElement('a');
        link.href = `#${id}`;
        link.textContent = heading.textContent;
        item.append(link);
        list.append(item);
      });
      toc.hidden = false;
    }
  }

  document.addEventListener('click', async (event) => {
    const share = event.target.closest('[data-journal-share]');
    if (share) {
      const url = share.dataset.shareUrl || window.location.href;
      const status = document.querySelector('[data-journal-share-status]');
      try {
        if (navigator.share) await navigator.share({ title: document.title, url });
        else await navigator.clipboard.writeText(url);
        if (status) status.textContent = navigator.share ? '' : 'Link copied';
      } catch (error) {
        if (error.name !== 'AbortError' && status) status.textContent = 'Copy the address from your browser';
      }
    }

    const tracked = event.target.closest('[data-journal-action], [data-journal-card] a');
    if (tracked) {
      const card = tracked.closest('[data-journal-card]');
      const detail = {
        event: 'journal_interaction',
        action: tracked.dataset.journalAction || 'article-card',
        source: card?.dataset.journalSource || '',
        destination: tracked.href || ''
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(detail);
      document.dispatchEvent(new CustomEvent('havn:journal-interaction', { detail }));
    }
  });
})();



/* HAVN editorial enrichments v1 */
(() => {
  const article = document.querySelector('[data-journal-content]');
  if (!article) return;

  const findHeading = (needle) => [...article.querySelectorAll('h2')].find((heading) => heading.textContent.toLowerCase().includes(needle));

  if (!article.querySelector('.havn-evidence-panel')) {
    const anchor = findHeading('is it love');
    if (anchor) {
      const panel = document.createElement('aside');
      panel.className = 'havn-evidence-panel';
      panel.setAttribute('aria-labelledby', 'havn-evidence-title');
      panel.innerHTML = '<p class="havn-evidence-panel__eyebrow">The short answer</p><h2 id="havn-evidence-title">Four motives can arrive at the same door</h2><div class="havn-evidence-panel__grid"><div><strong>Social contact</strong><span>You are a relevant member of your cat’s world.</span></div><div><strong>Routine</strong><span>Your movements predict familiar outcomes.</span></div><div><strong>Access</strong><span>A closed door removes information and choice.</span></div><div><strong>Environment</strong><span>Water, warmth, scent and stillness can all reward the visit.</span></div></div>';
      anchor.before(panel);
    }
  }

  if (!article.querySelector('.havn-inline-media')) {
    const anchor = findHeading('then there is the scandal');
    if (anchor) {
      const figure = document.createElement('figure');
      figure.className = 'havn-inline-media havn-full-width';
      figure.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0779/3167/5671/files/havn-journal-cat-closed-door-support.png?v=1790830309&width=1200" srcset="https://cdn.shopify.com/s/files/1/0779/3167/5671/files/havn-journal-cat-closed-door-support.png?v=1790830309&width=400 400w, https://cdn.shopify.com/s/files/1/0779/3167/5671/files/havn-journal-cat-closed-door-support.png?v=1790830309&width=800 800w, https://cdn.shopify.com/s/files/1/0779/3167/5671/files/havn-journal-cat-closed-door-support.png?v=1790830309&width=1200 1200w" sizes="(min-width: 990px) 900px, calc(100vw - 28px)" alt="A cat waiting calmly beside a nearly closed bathroom door" loading="lazy" decoding="async" fetchpriority="low" width="1536" height="1024"><figcaption>A closed door changes the experiment. Access, information and choice disappear at once.</figcaption>';
      anchor.before(figure);
    }
  }

  if (!article.querySelector('.havn-pullquote')) {
    const anchor = findHeading('what about scent');
    if (anchor) {
      const quote = document.createElement('blockquote');
      quote.className = 'havn-pullquote';
      quote.textContent = 'The prize may not be cuddling. It may simply be restored access, restored information or restored choice.';
      anchor.before(quote);
    }
  }
})();


/* HAVN record-holder archive gallery v1 */
(() => {
  if (!window.location.pathname.includes('/blogs/journal/worlds-oldest-cats-longevity-secrets')) return;
  const article = document.querySelector('[data-journal-content]');
  if (!article || article.querySelector('.havn-archive-gallery')) return;

  const anchor = [...article.querySelectorAll('p')].find((paragraph) =>
    paragraph.textContent.includes('The anecdotes refuse to line up. That is the point.')
  );
  if (!anchor) return;

  const gallery = document.createElement('aside');
  gallery.id = 'record-holder-gallery';
  gallery.className = 'havn-archive-gallery';
  gallery.setAttribute('aria-label', 'Three record-holding cats');
  gallery.innerHTML = `
    <p class="havn-archive-gallery__intro">Three more from the longevity club</p>
    <div class="havn-archive-gallery__grid">
      <figure class="havn-archive-card">
        <img src="https://cdn.shopify.com/s/files/1/0779/3167/5671/files/scooter-oldest-living-cat-guinness.jpg?v=1790996593&width=800" srcset="https://cdn.shopify.com/s/files/1/0779/3167/5671/files/scooter-oldest-living-cat-guinness.jpg?v=1790996593&width=400 400w, https://cdn.shopify.com/s/files/1/0779/3167/5671/files/scooter-oldest-living-cat-guinness.jpg?v=1790996593&width=800 800w" sizes="(min-width: 990px) 900px, calc(100vw - 28px)" alt="Scooter, a Siamese cat recognised at age 30" loading="lazy" decoding="async" fetchpriority="low" width="800" height="600">
        <figcaption><strong>Scooter, aged 30</strong>The famously well-travelled Siamese was recognised in 2016. Photo: <a href="https://www.guinnessworldrecords.com/news/2016/5/guinness-world-records-announces-30-year-old-scooter-as-oldest-living-cat-428117">Guinness World Records</a>.</figcaption>
      </figure>
      <figure class="havn-archive-card">
        <img src="https://cdn.shopify.com/s/files/1/0779/3167/5671/files/tiffany-two-oldest-living-cat-guinness.jpg?v=1790996600&width=800" srcset="https://cdn.shopify.com/s/files/1/0779/3167/5671/files/tiffany-two-oldest-living-cat-guinness.jpg?v=1790996600&width=400 400w, https://cdn.shopify.com/s/files/1/0779/3167/5671/files/tiffany-two-oldest-living-cat-guinness.jpg?v=1790996600&width=800 800w" sizes="(min-width: 990px) 900px, calc(100vw - 28px)" alt="Tiffany Two, a tortoiseshell cat who lived to age 27" loading="lazy" decoding="async" fetchpriority="low" width="800" height="600">
        <figcaption><strong>Tiffany Two, aged 26</strong>A ten-dollar kitten who grew into a world record holder. Photo: <a href="https://www.guinnessworldrecords.com/news/2015/2/california-cat-tiffany-two-claims-the-record-for-oldest-cat-living-370934">Guinness World Records</a>.</figcaption>
      </figure>
      <figure class="havn-archive-card">
        <img src="https://cdn.shopify.com/s/files/1/0779/3167/5671/files/flossie-oldest-living-cat-guinness.jpg?v=1790996596&width=800" srcset="https://cdn.shopify.com/s/files/1/0779/3167/5671/files/flossie-oldest-living-cat-guinness.jpg?v=1790996596&width=400 400w, https://cdn.shopify.com/s/files/1/0779/3167/5671/files/flossie-oldest-living-cat-guinness.jpg?v=1790996596&width=800 800w" sizes="(min-width: 990px) 900px, calc(100vw - 28px)" alt="Flossie, a brown and black cat recognised at almost 27 years old" loading="lazy" decoding="async" fetchpriority="low" width="800" height="600">
        <figcaption><strong>Flossie, almost 27</strong>Deaf, poorly sighted, playful and deeply committed to dinner. Photo: <a href="https://www.guinnessworldrecords.com/news/2022/11/worlds-oldest-cat-confirmed-at-almost-27-years-old-726391">Guinness World Records</a>.</figcaption>
      </figure>
    </div>`;
  anchor.after(gallery);
})();


/* HAVN primary-subject feature v1 */
(() => {
  if (!window.location.pathname.includes('/blogs/journal/worlds-oldest-cats-longevity-secrets')) return;
  const article = document.querySelector('[data-journal-content]');
  if (!article || article.querySelector('.havn-subject-feature')) return;

  const anchor = [...article.querySelectorAll('p')].find((paragraph) =>
    paragraph.textContent.includes('Crème Puff, the oldest cat ever verified')
  );
  if (!anchor) return;

  const feature = document.createElement('figure');
  feature.id = 'creme-puff-feature';
  feature.className = 'havn-subject-feature';
  feature.innerHTML = `
    <div class="havn-subject-feature__media">
      <img src="https://cdn.shopify.com/s/files/1/0779/3167/5671/files/creme-puff-oldest-cat-1996.jpg?v=1790997741&width=900" srcset="https://cdn.shopify.com/s/files/1/0779/3167/5671/files/creme-puff-oldest-cat-1996.jpg?v=1790997741&width=400 400w, https://cdn.shopify.com/s/files/1/0779/3167/5671/files/creme-puff-oldest-cat-1996.jpg?v=1790997741&width=800 800w" sizes="(min-width: 990px) 900px, calc(100vw - 28px)" alt="Crème Puff, the oldest verified cat ever, photographed in 1996 at age 29" loading="lazy" decoding="async" fetchpriority="low" width="900" height="675">
    </div>
    <figcaption>
      <p class="havn-subject-feature__eyebrow">The record holder</p>
      <strong class="havn-subject-feature__title">Crème Puff</strong>
      <span>Photographed in 1996 at age 29. She lived for another nine years, reaching 38 years and three days. Image: <a href="https://en.wikipedia.org/wiki/Creme_Puff_(cat)">archival photograph via Wikipedia</a>.</span>
    </figcaption>`;
  anchor.after(feature);
})();
